// extracted by mini-css-extract-plugin
export default {"BrandNumbers":"BrandNumbers_BrandNumbers__1vSiu"};